import type { HitoEstado } from '@/types';
import styles from './facility-tabs.module.css';

interface EstadoSelectProps {
  value: HitoEstado;
  onChange: (estado: HitoEstado) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

export const ESTADO_META: Record<
  HitoEstado,
  { label: string; color: string; bg: string; border: string }
> = {
  pendiente:  { label: 'Pendiente',  color: '#475569', bg: '#f1f5f9', border: '#cbd5e1' },
  on_track:   { label: 'On Track',   color: '#1d4ed8', bg: '#dbeafe', border: '#93c5fd' },
  bloqueado:  { label: 'Bloqueado',  color: '#b91c1c', bg: '#fee2e2', border: '#fca5a5' },
  suspendido: { label: 'Suspendido', color: '#b45309', bg: '#fef3c7', border: '#fcd34d' },
  entregado:  { label: 'Entregado',  color: '#047857', bg: '#d1fae5', border: '#6ee7b7' },
};

export const ESTADO_ORDER: HitoEstado[] = [
  'pendiente',
  'on_track',
  'bloqueado',
  'suspendido',
  'entregado',
];

export function EstadoSelect({ value, onChange, disabled, ariaLabel }: EstadoSelectProps) {
  const meta = ESTADO_META[value] ?? ESTADO_META.pendiente;
  return (
    <select
      className={styles.estadoSelect}
      value={value}
      onChange={(e) => onChange(e.target.value as HitoEstado)}
      style={{ background: meta.bg, color: meta.color, borderColor: meta.border }}
      disabled={disabled}
      aria-label={ariaLabel || 'Estado del hito'}
      onClick={(e) => e.stopPropagation()}
    >
      {ESTADO_ORDER.map((e) => (
        <option key={e} value={e}>
          {ESTADO_META[e].label}
        </option>
      ))}
    </select>
  );
}
